import { api } from './client';

/*  Specchio dei contratti di TeraWorks.Application.Acquisti.

    Chi agisce non compare in nessuno di questi corpi, e prima ci compariva: questo
    modulo aggiungeva `operatoreId` prendendolo dalla sessione. Ora l'autore lo stabilisce
    il server dalla richiesta autenticata, quindi qui non c'è niente da aggiungere né da
    dimenticare — e un client non può più firmare un documento col nome di un altro.  */

export type StatoRichiesta = 'Bozza' | 'Inviata' | 'Annullata';
export type Evasione = 'Nessuna' | 'Parziale' | 'Completa';
export type StatoOrdine = 'Bozza' | 'Inviato' | 'Annullato';
export type Consegna = 'Attesa' | 'Parziale' | 'Completa';

export interface RigaRichiesta {
  id: string;
  posizione: number;
  articoloId: string | null;
  siglaProduttore: string | null;
  codiceArticoloProduttore: string | null;
  descrizione: string;
  unitaMisura: string | null;
  quantita: number;
  quantitaOrdinata: number;
  quantitaChiusa: number;
  motivoChiusura: string | null;
  residuo: number;
  eccedenza: number;
  daCodificare: boolean;
  fornitoreSuggeritoMago: string | null;
  fornitoreSuggerito: string | null;
  costoStimato: number | null;
  note: string | null;
  /** La riga del preventivo da cui nasce. Null se scritta a mano. */
  rigaPreventivoId: string | null;
}

export interface DettaglioRichiesta {
  id: string;
  numero: string | null;
  codiceSede: string;
  stato: StatoRichiesta;
  evasione: Evasione;
  commessaId: string;
  commessa: string | null;
  cliente: string | null;
  richiedenteId: string;
  richiedente: string | null;
  dataRichiesta: string;
  dataFabbisogno: string;
  descrizione: string;
  note: string | null;
  motivoAnnullamento: string | null;
  ordinabile: boolean;
  valoreStimato: number;
  righe: RigaRichiesta[];
}

export interface OffertaPerAcquisto {
  codiceFornitoreMago: string;
  fornitore: string | null;
  codiceArticoloFornitore: string | null;
  costoNetto: number;
  scontoPercentuale: number;
  scontoTesto: string | null;
  origine: string;
  confezioneMinima: number | null;
  scontoSulListinoProduttore: number | null;
  differenzaDallaMigliore: number | null;
  differenzaPercentuale: number | null;
  migliore: boolean;
}

export interface RigaDaPreparare {
  rigaRichiestaId: string;
  richiestaId: string;
  numeroRichiesta: string | null;
  commessaId: string;
  commessa: string | null;
  dataFabbisogno: string;
  giorniAlFabbisogno: number;
  articoloId: string | null;
  siglaProduttore: string | null;
  codiceArticoloProduttore: string | null;
  descrizione: string;
  unitaMisura: string | null;
  quantita: number;
  daOrdinare: number;
  fornitoreSuggeritoMago: string | null;
  fornitoreSuggerito: string | null;
  costoStimato: number | null;
  offerte: OffertaPerAcquisto[];
  problema: string | null;
  ordinabile: boolean;
  migliorCostoOggi: number | null;
}

export interface PreparazioneOrdini {
  righe: RigaDaPreparare[];
  mancanti: string[];
}

export interface RigaDaOrdinare {
  rigaRichiestaId: string;
  codiceFornitoreMago: string;
  quantita: number;
  costoNetto: number;
  codiceArticoloFornitore?: string | null;
}

export interface OrdineCreato {
  id: string;
  numero: string;
  codiceFornitoreMago: string;
  fornitore: string | null;
  righe: number;
  totale: number;
}

export interface RigaOrdine {
  id: string;
  posizione: number;
  rigaRichiestaAcquistoId: string | null;
  numeroRichiesta: string | null;
  commessaId: string;
  commessa: string | null;
  articoloId: string | null;
  siglaProduttore: string | null;
  codiceArticoloProduttore: string | null;
  codiceArticoloFornitore: string | null;
  descrizione: string;
  unitaMisura: string | null;
  quantita: number;
  prezzoListino: number | null;
  scontoPercentuale: number;
  scontoTesto: string | null;
  costoNetto: number;
  importo: number;
  quantitaRicevuta: number;
  quantitaRifiutata: number;
  quantitaChiusa: number;
  motivoChiusura: string | null;
  residuo: number;
  eccedenza: number;
  completata: boolean;
  note: string | null;
}

/*  Specchio di DestinazioneConsegna (15/10/2026): sede, cantiere o ritiro al banco.
    `indirizzo` e' quello che finisce scritto sull'ordine.  */
export interface DestinazioneConsegna {
  tipo: 'Sede' | 'Cantiere' | 'Banco';
  etichetta: string;
  indirizzo: string;
}

export interface DettaglioOrdine {
  id: string;
  numero: string | null;
  codiceSede: string;
  stato: StatoOrdine;
  consegna: Consegna;
  codiceFornitoreMago: string;
  fornitore: string | null;
  dataOrdine: string;
  consegnaRichiesta: string | null;
  consegnaConfermata: string | null;
  riferimentoFornitore: string | null;
  confermato: boolean;
  inRitardo: boolean;
  indirizzoConsegna: string | null;
  note: string | null;
  motivoAnnullamento: string | null;
  caricabile: boolean;
  totale: number;
  righe: RigaOrdine[];
}

export interface RigaNuovoCarico {
  rigaOrdineFornitoreId: string;
  accettata: number;
  rifiutata?: number;
  motivoRifiuto?: string | null;
  note?: string | null;
}

export interface RigaCarico {
  id: string;
  rigaOrdineFornitoreId: string;
  numeroOrdine: string | null;
  descrizione: string;
  unitaMisura: string | null;
  quantitaAccettata: number;
  quantitaRifiutata: number;
  motivoRifiuto: string | null;
  note: string | null;
}

export interface DettaglioCarico {
  id: string;
  numero: string | null;
  codiceSede: string;
  stato: 'Registrato' | 'Annullato';
  codiceFornitoreMago: string;
  fornitore: string | null;
  numeroDdt: string;
  dataDdt: string;
  dataRicevimento: string;
  ricevutoDaId: string;
  ricevutoDa: string | null;
  note: string | null;
  motivoAnnullamento: string | null;
  haNonConformita: boolean;
  righe: RigaCarico[];
}

export interface AnagraficaMago {
  codiceMago: string;
  denominazione: string;
  citta: string | null;
  provincia: string | null;
  attiva: boolean;
  /*  Come Galizzi distingue i clienti in Mago: Ditte, Privati, Condomini, Enti
      pubblici, Edili, Partecipate, Gestione calore. È la categoria che il preventivo
      nuovo propone invece di farla scegliere a mano. Sui fornitori è sempre nulla, e
      può mancare anche su un cliente che nessuno ha ancora classificato.  */
  codiceClassificazione: string | null;
  classificazione: string | null;
}

/** Una classe di clienti come la elenca Mago: per la tendina del preventivo nuovo. */
export interface ClassificazioneCliente {
  codice: string;
  descrizione: string;
}

export interface NuovaRichiestaAcquisto {
  commessaId: string;
  descrizione: string;
  dataFabbisogno: string;
  note?: string | null;
}

export interface NuovaRigaRichiesta {
  quantita: number;
  articoloId?: string | null;
  descrizione?: string | null;
  unitaMisura?: string | null;
  note?: string | null;
  dopoRigaId?: string | null;
  primaRigaId?: string | null;
}

/** Un materiale del preventivo della commessa, con quanto se n'è già chiesto. */
export interface MaterialeDaPreventivo {
  rigaPreventivoId: string;
  capitolo: string | null;
  descrizione: string;
  siglaProduttore: string | null;
  codiceArticoloProduttore: string | null;
  unitaMisura: string | null;
  preventivata: number;
  giaRichiesta: number;
  daRichiedere: number;
}

export interface RigaDalPreventivo {
  rigaPreventivoId: string;
  quantita: number;
}

export const richieste = {
  leggi: (id: string) => api.get<DettaglioRichiesta>(`/rda/${id}`),

  crea: (nuova: NuovaRichiestaAcquisto) => api.post<DettaglioRichiesta>('/rda', nuova),

  aggiungiRiga: (id: string, riga: NuovaRigaRichiesta) =>
    api.post<DettaglioRichiesta>(`/rda/${id}/righe`, riga),

  materialiPreventivo: (commessaId: string) =>
    api.get<MaterialeDaPreventivo[]>(`/rda/materiali-preventivo/${commessaId}`),

  aggiungiDalPreventivo: (id: string, righe: RigaDalPreventivo[]) =>
    api.post<DettaglioRichiesta>(`/rda/${id}/dal-preventivo`, { righe }),

  invia: (id: string) => api.post<DettaglioRichiesta>(`/rda/${id}/invia`, {}),

  riportaInBozza: (id: string) => api.post<DettaglioRichiesta>(`/rda/${id}/bozza`, {}),

  annulla: (id: string, motivo: string) =>
    api.post<DettaglioRichiesta>(`/rda/${id}/annulla`, { motivo }),

  chiudiResiduoRiga: (id: string, rigaId: string, motivo: string) =>
    api.post<DettaglioRichiesta>(`/rda/${id}/righe/${rigaId}/chiudi`, { motivo }),

  rimuoviRiga: (id: string, rigaId: string) =>
    api.post<DettaglioRichiesta>(`/rda/${id}/righe/${rigaId}/rimuovi`, {}),
};

export const ordini = {
  prepara: (righeRichiestaId: string[]) =>
    api.post<PreparazioneOrdini>('/ordini/preparazione', { righeRichiestaId }),

  crea: (righe: RigaDaOrdinare[], consegnaRichiesta?: string, indirizzoConsegna?: string) =>
    api.post<OrdineCreato[]>('/ordini', {
      righe,
      consegnaRichiesta: consegnaRichiesta ?? null,
      indirizzoConsegna: indirizzoConsegna ?? null,
    }),

  leggi: (id: string) => api.get<DettaglioOrdine>(`/ordini/${id}`),

  /** Dove può arrivare la merce: la sede per prima, poi i cantieri, poi il banco. */
  destinazioni: (id: string) => api.get<DestinazioneConsegna[]>(`/ordini/${id}/destinazioni`),

  invia: (id: string, consegnaRichiesta: string, indirizzoConsegna?: string, referente?: string) =>
    api.post<DettaglioOrdine>(`/ordini/${id}/invia`, {
      consegnaRichiesta,
      indirizzoConsegna: indirizzoConsegna ?? null,
      referente: referente ?? null,
    }),

  conferma: (id: string, riferimentoFornitore: string, consegnaConfermata?: string) =>
    api.post<DettaglioOrdine>(`/ordini/${id}/conferma`, {
      riferimentoFornitore,
      consegnaConfermata: consegnaConfermata ?? null,
    }),

  annulla: (id: string, motivo: string) =>
    api.post<DettaglioOrdine>(`/ordini/${id}/annulla`, { motivo }),

  chiudiResiduoRiga: (id: string, rigaId: string, motivo: string) =>
    api.post<DettaglioOrdine>(`/ordini/${id}/righe/${rigaId}/chiudi`, { motivo }),
};

export const carichi = {
  registra: (carico: {
    codiceFornitoreMago: string;
    numeroDdt: string;
    dataDdt: string;
    dataRicevimento: string;
    righe: RigaNuovoCarico[];
    note?: string | null;
  }) =>
    // Chi registra la bolla è chi ha ricevuto la merce, e lo sa il server: la persona
    // che risponde di quello che ha contato in magazzino non è un campo del corpo.
    api.post<DettaglioCarico>('/carichi', carico),

  leggi: (id: string) => api.get<DettaglioCarico>(`/carichi/${id}`),

  annulla: (id: string, motivo: string) =>
    api.post<DettaglioCarico>(`/carichi/${id}/annulla`, { motivo }),
};

export const anagrafiche = {
  fornitori: (frase: string) =>
    api.get<AnagraficaMago[]>(`/anagrafiche/fornitori?q=${encodeURIComponent(frase)}&max=15`),

  /*  Clienti e fornitori hanno due rotte e non una ricerca sola: in Mago il codice è
      unico solo dentro il proprio tipo, e lo stesso codice può essere un cliente e un
      fornitore diversi. Cercare senza dire quale dei due si vuole restituirebbe
      l'azienda sbagliata senza dare errore.  */
  clienti: (frase: string) =>
    api.get<AnagraficaMago[]>(`/anagrafiche/clienti?q=${encodeURIComponent(frase)}&max=15`),

  /*  I cantieri gia' visti su quel cliente: le filiali che Mago tiene agganciate
      all'anagrafica, piu' gli indirizzi che qualcuno ha scritto a mano sui documenti di
      prima. Un cantiere spesso non e' una sede del cliente — un condominio, una villa, un
      capannone in affitto — e riscriverlo ogni volta vuol dire scriverlo leggermente
      diverso, con Google che restituisce altri chilometri per lo stesso posto.  */
  cantieri: (codiceClienteMago: string) =>
    api.get<CantiereMago[]>(`/anagrafiche/clienti/${encodeURIComponent(codiceClienteMago)}/cantieri`),

  /*  Le classi in cui Mago divide i clienti. Si chiedono a lui e non si tengono qui:
      erano quattro voci scritte dentro la schermata — «Impianti civili», «Impianti
      industriali» — che non corrispondevano a niente di quello che l'azienda usa
      davvero.  */
  classificazioniCliente: () =>
    api.get<ClassificazioneCliente[]>('/anagrafiche/classificazioni-cliente'),

  /*  Le modalità di pagamento come le tiene Mago, non più come testi scritti qui:
      l'amministrazione le gestisce di là, una volta sola, e i preventivi le leggono.
      Solo le attive — una condizione disabilitata non deve poter finire su
      un'offerta nuova; su quelle vecchie resta, congelata com'era.  */
  pagamenti: () => api.get<PagamentoMago[]>('/anagrafiche/pagamenti'),

  /*  PZ, MT, KG: l'unità di misura di una riga d'offerta. Anche questa da Mago e non
      scritta qui, perché è quella con cui il magazzino carica e con cui escono le
      bolle — un secondo elenco farebbe misurare l'offerta in un modo e la bolla in un
      altro. La vista scarta le voci senza descrizione, che in Galizzi sono descrizioni
      di articolo finite nel campo sbagliato.  */
  unitaMisura: () => api.get<UnitaMisuraMago[]>('/anagrafiche/unita-misura'),
};

/** Una condizione di pagamento di Mago: il codice per salvarla, la frase per leggerla. */
export interface PagamentoMago {
  codice: string;
  descrizione: string;
}

/** Un'unità di misura di Mago: «PZ» è quello che finisce in offerta, «Pezzi» quello che si legge. */
export interface UnitaMisuraMago {
  codice: string;
  descrizione: string;
}

export interface CantiereMago {
  codice: string | null;
  denominazione: string | null;
  indirizzoCompleto: string | null;
  citta: string | null;
  provincia: string | null;
  /** 'Mago' se viene dall'anagrafica, 'Storico' se da un documento già fatto. */
  origine: string;
  attiva: boolean;
}

export const ETICHETTE_ORIGINE_ACQUISTO: Record<string, string> = {
  NettoDaListinoFornitore: 'netto da listino',
  ScontoDaListinoFornitore: 'sconto su listino',
  ScontoDaGriglia: 'griglia sconti',
  UltimoAcquisto: 'ultimo acquisto',
};
